module.exports = __webpack_public_path__ + "build/static/media/marker.ab5ffb79.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/marker.svg
// module id = 278
// module chunks = 6